// this is a dropdown component
// it include the dropdown button and label
// all the setting is passed in using props
// onChange function is in parent
import { React } from "react";

const Dropdown = (props) => {
  let data = convertData(props.data, props.selectedItem);

  //let selectedLabel = getSelectedLabel(props.data, props.selectedItem);
  //let selectedValue = getSelectedValue(props.data, props.selectedItem);
  // var selectedId;
  // var selectedLabel = false;
  // var selectedValue = "DEFAULT";
  //var selected_changed;

  //const [selectedLabel, setSelectedLabel] = useState(false);
  //const [selectedValue, setSelectedValue] = useState("DEFAULT");

  // useEffect(() => {

  //   // fetching location data
  //   selected_changed = false;

  //   //init();

  // }, []); // <-- empty array here make it only rnu once

  function noSelectedItem() {
    if (
      (props.disableDefault === undefined ||
        props.disableDefault === null ||
        props.disableDefault !== true) &&
      (props.selectedItem === undefined ||
        props.selectedItem === null ||
        props.selectedItem === "" ||
        props.selectedItem.id === undefined ||
        props.selectedItem.id === null ||
        props.selectedItem.id === ""          
        )
    ) {

      return (
        <option
          selected
          value=""
          className="dropdown__item"
          key="0"
          disabled={props.isRequired}
        >
          Select one
        </option>
      );
    } else {

      return (
        <option
          value=""
          className="dropdown__item"
          key="0"
          disabled={props.isRequired}
        >
          Select one
        </option>
      );
    }
  }

  function convertData(ary, selectedItem) {


    if (Array.isArray(ary) && ary.length > 0) {
      let newAry = [];
      for (let i = 0; i < ary.length; i++) {
        let id;
        let label;
        let value;
        let selected;
        let name;
        let activeInd;

        // get id, it can be index(if not found) or type of number or type of string
        if (ary[i].id !== undefined || ary[i].id !== null) {
          if (typeof ary[i].id === "number") {
            id = ary[i].id;
          } else {
            id = ary[i].id.toString();
          }
        } else {
          id = i;
        }

        // get value, can be name, or null
        if (ary[i].value !== undefined && ary[i].value !== null) {
          value = ary[i].value;
        } else {
          value = ary[i].id;
        }

        // get label, can be either label or name or value or index
        if (ary[i].label !== undefined && ary[i].label !== null) {
          label = ary[i].label;
        } else if (ary[i].name !== undefined) {
          label = ary[i].name;
        } else if (ary[i].value !== undefined) {
          label = ary[i].value;
        } else {
          label = i;
        }

        // compare selectedItem
        // get selected, if not found, set to false
        // check input selectedItem, then check if the json has selected field, all else set to false
        //if (!selected_changed) {
        if (
          selectedItem !== undefined && selectedItem !== null &&
          selectedItem.id !== undefined && selectedItem.id !== null
        ) {
          if (ary[i].id.toString() === selectedItem.id.toString()) {
            selected = true;
            //this.selectedLabel = label;
            //this.setSelectedValue(value);
            //setSelectedLabel(label);
            // selectedId = id;
            // selectedValue = value;
            // selectedLabel = label;
          } else {
            selected = false;
          }
        } else if (ary[i].selected !== undefined && ary[i].selected !== null) {
          selected = ary[i].selected;
        } else {
          selected = false;
        }
        //}

        // get name
        if (ary[i].name !== undefined && ary[i].name !== null) {
          name = ary[i].name.toString();
        } else {
          name = "";
        }

        // get activeInd
        if (ary[i].activeInd !== undefined && ary[i].activeInd !== null) {
          activeInd = ary[i].activeInd;
        } else {
          activeInd = true;
        }

        newAry.push({
          id: id,
          label: label,
          value: value,
          selected: selected,
          name: name,
          activeInd: activeInd
        });
      }

      // on setup, if has selected, return selected, else return []
      //props.value(newAry.filter((item) => item.selected === true));
      return newAry;
    } else {

      // set value to empty array
      //props.value([]);
      return [];
    }
  }

  /*
  // get selected item's label/name or output as string
  function getSelectedLabel(ary, selectedItem) {
    let str = "";
    if (ary !== undefined && selectedItem !== undefined && selectedItem !== null) {
      if (
        ary.find((item) => item.id === selectedItem.id) !== undefined &&
        ary.find((item) => item.id === selectedItem.id) !== null
      ) {
        if (
          ary.find((item) => item.id === selectedItem.id).label !== undefined &&
          ary.find((item) => item.id === selectedItem.id).label.length > 0
        ) {
          str = ary.find((item) => item.id === selectedItem.id).label;
        } else if (
          ary.find((item) => item.id === selectedItem.id).name !== undefined &&
          ary.find((item) => item.id === selectedItem.id).name.length > 0
        ) {
          str = ary.find((item) => item.id === selectedItem.id).name;
        } else {
          str = JSON.stringify(ary.find((item) => item.id === selectedItem.id));
        }
      }
    }

    return str;
  }
  
    // get selected item's value/id
  function getSelectedValue(ary, selectedItem) {
    let val = "";
    if (ary !== undefined && selectedItem !== undefined && selectedItem !== null) {
      if (
        ary.find((item) => item.id === selectedItem.id) !== undefined &&
        ary.find((item) => item.id === selectedItem.id) !== null
      ) {
        if (
          ary.find((item) => item.id === selectedItem.id).value !== undefined &&
          ary.find((item) => item.id === selectedItem.id).value.length > 0
        ) {
          val = ary.find((item) => item.id === selectedItem.id).value;
        } else  {
          val = ary.find((item) => item.id === selectedItem.id).id;
        }
      }
    }

    return val;
  }
  */
  // on load, check the data array has a pre selected value
  // if yes, return the selected value
  // if not, return "DEFAULT"
  // and in selected tag set the defaultValue={selectedValue}
  // const [selectedValue, setSelectedValue] = useState(findDefaultValue);
  // function findDefaultValue() {

  //   for (var i = 0; i < props.data.length; i++) {
  //     if (props.data[i].selected === true) {
  //       return props.data[i].value;
  //     }
  //   }
  //   return "DEFAULT";
  // }

  function defaultOnChange(e) {

    if (
      props.data.find(
        (item) => item.id.toString() === e.currentTarget.value.toString()
      ) !== undefined
    ) {
      if (
        props.getSelectedValue === undefined ||
        props.getSelectedValue === null
      ) {

      } else {

        props.getSelectedValue(
          props.data.find(
            (item) => item.id.toString() === e.currentTarget.value.toString()
          )
        );
        props.onChange(
          props.data.find(
            (item) => item.id.toString() === e.currentTarget.value.toString()
          )
        );
        //props.value(props.data.find(item=>item.id==e.currentTarget.value));
        //props.onChange(props.data[e.target.getAttribute("index")]);
        //props.selectedItem(props.data.find(item=>item.id==e.currentTarget.value));
        // selectedId = data.find(item=>item.id==e.currentTarget.value).id;
        // selectedValue = data.find(item=>item.id==e.currentTarget.value).value;
        // selectedLabel = data.find(item=>item.id==e.currentTarget.value).label;
        // selected_changed = true;

        data.forEach((item) => (item.selected = false));
        data.find(
          (item) => item.id.toString() === e.currentTarget.value.toString()
        ).selected = true;
      }
    } else if (e.currentTarget.value !== "Select one") {
      // user selected default item, use name to match value
      props.getSelectedValue(
        data.find(
          (item) => item.name.toString() === e.currentTarget.value.toString()
        )
      );
      props.onChange(
        props.data.find(
          (item) => item.id.toString() === e.currentTarget.value.toString()
        )
      );
    } else {
      props.getSelectedValue({});
      props.onChange({});
    }
  }

  function defaultOnBlur(e) {
	  // return value if user pick 
      if (
        e.currentTarget.value !== undefined &&
        e.currentTarget.value !== null &&
        e.currentTarget.value !== ""
      ) {
        props.getSelectedValue(
          data.find(
            (item) => item.id.toString() === e.currentTarget.value.toString()
          )
        );
      } 
    
      // run default onBlur event
	  if (props.onBlur !== undefined && props.onBlur !== null) {
	      props.onBlur(e);
	  }    
    
  }

  function defaultOnFocus(e) {
    if (props.onFocus !== undefined && props.onFocus !== null) {
      props.onFocus(true);
    }
  }

  let j = 0;
  return (
    <div className="dropdown__container">
      <label
        className={`dropdown__label ${
          props.isDisabled ? "dropdown__label--disabled" : ""
        }
      ${props.hasError ? "dropdown__label--error" : ""}
      `}
      >
        {props.label}
        <span
          className={`dropdown__required  ${
            props.isRequired
              ? "dropdown__required--show"
              : "dropdown__required--hide"
          }`}
        >
          *
        </span>
      </label>
      <div className="dropdown__div">
        <select
          className={`dropdown__box 
          ${props.hasError ? "dropdown__box--error" : ""}
          `}
          disabled={props.isDisabled ? "disabled" : null}
          //value={selectedValue}
          defaultValue={"DEFAULT"}
          //value={(props.selectedItem !== undefined && props.selectedItem.id !== undefined )?props.selectedItem.id :"DEFAULT"}
          //value={data.find(item=>item.selected===true) !== undefined?data.find(item=>item.selected===true).value:"DEFAULT"}
          //value={selectedValue}
          //value={"DEFAULT"}
          //defaultValue={props.selectedItem ? props.selectedItem.id : "DEFAULT"}
          //value={props.selectedItem ? props.selectedItem.id : "DEFAULT"}
          onChange={(e) => defaultOnChange(e)}
          onBlur={(e) => defaultOnBlur(e)}
          onFocus={(e) => defaultOnFocus(e)}
          id={props.id}
          aria-label={props.label}
        >
          {/* <option
            className="dropdown__instruction"
            value={data.filter((item) => item.selected === true).value}
            disabled={props.disableDefault}
            hidden={props.disableDefault} //disableDefault
            key={j++}
          > */}
          {/* Allows us to set the label for the default selected option. 
          	  Defaults to "Select one" if not passed in as a prop 
            {props.defaultLabel ? props.defaultLabel : "Select one"}*/}
          {/* {data.find(item=>item.selected===true) !== undefined?data.find(item=>item.selected===true).label : "Select one"} */}
          {/* Select one */}
          {/* {(props.selectedItem !== undefined && props.selectedItem.name !== undefined )? props.selectedItem.name :"Select one" } */}
          {/* {selectedLabel != undefined || selectedLabel != ""? selectedLabel : "Select one"} */}

          {/* {props.selectedItem ? props.selectedItem.name : "Select one"} */}
          {/* {this.selectedLabel.length > 0 ? this.selectedLabel : "Select one"} */}
          {/* {selectedLabel !== undefined && selectedLabel.length > 0
              ? selectedLabel
              : "Select one"} */}
          {/* </option> */}

          {noSelectedItem()}
          {data.map((item) => (
            <option
              className="dropdown__item"
              value={item.id}
              key={j++}
              selected={item.selected === true ? true : null}
            >
              {item.label !== undefined ? item.label : item.title}
            </option>
          ))}
        </select>
      </div>
      <span className="inputbox__help">{props.helpMessage}</span>
      <span
        className="inputbox__error"
        style={props.hasError ? {} : { display: "none" }}
      >
        {props.errorMessage}
      </span>
    </div>
  );
};

export default Dropdown;
